import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';

export default function ModalInfoStromverbrauch() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return (<Panel >
            <h1 id="modal-title">Stromverbrauch</h1>
            <PanelImg src="Durchschnittliche_Stromverbraeuche_nach_Personen_250521.png" />
             <ModalClose label={"weiter"} onClick={()=>{
                            pop_modal();
                        }}/>
         </Panel>)
}

